
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transitPrices",
      function () {
        return require("private-next-pages/transitPrices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transitPrices"])
      });
    }
  